import React from 'react';
import { Link } from 'react-router-dom';
import './FooterCustomStyles.css'; // Importăm stilurile personalizate

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer>
      <div className="footer-top">
        <div>
          <Link to="/" className="footer-logo">aplica-startup.ro</Link>
          <p className="footer-text">Informații și sprijin la înscrierea la cursurile de antreprenoriat Start-Up Nation 2026 și la pregătirea dosarului de finanțare.</p>
        </div>
        
        <div>
          <h4 className="footer-title">Link-uri utile</h4>
          <ul className="footer-links">
            <li><Link to="/">Acasă</Link></li>
            <li><Link to="/despre-program#about-program">Despre Program</Link></li>
            <li><Link to="/login?role=trainer">Formatori</Link></li>
            <li><Link to="/login?role=partner">Parteneri</Link></li>
                        <li><Link to="/termeni-conditii#terms-and-conditions">Termeni și condiții</Link></li>
            <li><Link to="/politica-confidentialitate#privacy-policy">Politica de confidențialitate</Link></li>
          </ul>
        </div>
        
        <div>
          <h4 className="footer-title">Contact</h4>
          
          <div className="footer-contact-item">
            <div className="footer-contact-icon">✉️</div>
            <div className="footer-contact-text">contact@aplica-startup.ro</div>
          </div>
          
          <div className="footer-contact-item">
            <div className="footer-contact-icon">📍</div>
            <div className="footer-contact-text">București, România</div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {currentYear} aplica-startup.ro. Toate drepturile rezervate.</p>
        
        <div className="eu-funding">
          <p>aplica-startup.ro este un site independent de informare și sprijin. Nu este site guvernamental și nu reprezintă MEDAT, AIMMAT sau MIPE. Înscrierea oficială se face exclusiv pe minimis.imm.gov.ro.</p>
        </div>
        
        <div className="official-links">
          <a href="https://minimis.imm.gov.ro" target="_blank" rel="noopener noreferrer">Platforma oficială de înscriere: minimis.imm.gov.ro</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;